import React from 'react';

import Layout from '../components/Layout';

class KeysPastDue extends React.Component {

    render(){
        return(
            <Layout>
                <h1>Keys Past Due</h1>
            </Layout>
        );
    }
}

export default KeysPastDue;